"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var MoveToInboxFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_MoveToInboxFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0a.5.5 0 0 0-.5.5v5.293L5.354 3.646a.5.5 0 1 0-.708.707l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.707L8.5 5.793V.5A.5.5 0 0 0 8 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.446 4.5h-.032c-.072.204-.19.396-.353.56l-3 3a1.5 1.5 0 0 1-2.122 0l-3-3a1.494 1.494 0 0 1-.353-.56h-.032a1.5 1.5 0 0 0-1.272.705L.222 8.5H5A1.5 1.5 0 0 1 6.5 10a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5A1.5 1.5 0 0 1 11 8.5h4.777l-2.06-3.295a1.5 1.5 0 0 0-1.271-.705Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9.5v5A1.5 1.5 0 0 0 1.5 16h13a1.5 1.5 0 0 0 1.5-1.5v-5h-5a.5.5 0 0 0-.5.5A1.5 1.5 0 0 1 9 11.5H7A1.5 1.5 0 0 1 5.5 10a.5.5 0 0 0-.5-.5H0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_MoveToInboxFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = MoveToInboxFill;
exports["default"] = _default;